const moment = require('moment-timezone');

angular.module('app.member', ['ngRoute', 'ngResource', 'angular-jwt', 'ngFileUpload', 'bw.paging'])
    .config(['$routeProvider', ($routeProvider) => {
      $routeProvider.when('/login', {
        template: require('./login.html'),
        controller: 'LoginCtrl',
      })
      .when('/members', {
        template: require('./list.html'),
        controller: 'MemberLstCtrl',
      })
      .when('/member/:user_id/wash/history', {
        template: require('./washHistory.html'),
        controller: 'memberWashHistory',
      })
      .when('/members/add', {
        template: require('./add.html'),
        controller: 'MemberAddCtrl',
      });
    }])
    .controller('LoginCtrl', ($rootScope, $scope, $translate, $resource, $route, $location, $cookies, $window, envService) => {
      const APIURL = envService.read('apiUrl');
      $scope.user = { ID: '', PASSWORD: '' };
      $scope.doLogin = () => {
        if ($scope.user.ID.length < 1) {
          alert($translate.instant('아이디를 입력해주세요.'));
          return;
        }
        if ($scope.user.PASSWORD.length < 1) {
          alert($translate.instant('비밀번호를 입력해주세요.'));
          return;
        }
        $resource(`${APIURL}/admin/login`).save($scope.user,
            (data) => {
              $cookies.put('token', data.jwt);
              $cookies.put('user', JSON.stringify(data.adminUser));
              $scope.$emit('app.LoginStatusChangedEvent');
              if (data.adminUser.LEVEL < 99) {
                $location.path('/washes/count');
              } else {
                $location.path('/members');
              }
            }, (err) => {
              console.error(err);
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
      };
    })
    .controller('MemberLstCtrl', ($rootScope, $scope, $translate, $resource, $route, $location, $cookies, $window, AuthService, envService) => {
      $rootScope.mainmenu = 'members';
      $rootScope.menu = 'users';
      const APIURL = envService.read('apiUrl');
      if (!AuthService.isAuthenticated()) {
        $location.path('/login');
        return;
      }
      $scope.countryCode = AuthService.loginMember().COUNTRY_CODE;
      $scope.loginMember = AuthService.loginMember();
      $scope.total_count = 0;
      $scope.query = '';
      $scope.lastPage = 1;
      $scope.isLoading = true;
      $resource(`${APIURL}/admin/users`).get({ q: $scope.query }, (data) => {
        $scope.users = data.users;
        $scope.total_count = data.total_count;
        $scope.isLoading = false;
      }, (err) => {
        $scope.isLoading = false;
        console.error(err);
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });
      const alertError = (err) => {
        console.error(err);
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      };
      $scope.paging = (page) => {
        $scope.lastPage = page;
        $scope.isLoading = true;
        $resource(`${APIURL}/admin/users`).get({ page: page - 1, q: $scope.query },
          (data) => {
            $scope.users = data.users;
            $scope.total_count = data.total_count;
            $scope.isLoading = false;
          }, (err) => {
            $scope.isLoading = false;
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
      };

      $scope.displayJoinMethod = (user) => {
        if (!user || !user.JOIN_METHOD) {
          return '-';
        }
        let text = $translate.instant('이메일');
        if (user.JOIN_METHOD.indexOf('2') > -1) {
          text = `${text},${$translate.instant('페이스북')}`;
        }
        if (user.JOIN_METHOD.indexOf('4') > -1) {
          text = `${text},${$translate.instant('카카오톡')}`;
        }
        if (user.JOIN_METHOD.indexOf('5') > -1) {
          text = `${text},${$translate.instant('네이버')}`;
        }
        return text;
      };

      $scope.view = (user) => {
        $resource(`${APIURL}/admin/user/blacklist/payonsite/${user.ID}/check`).get().$promise
          .then((data) => {
            $scope.isUserOnPayOnSiteBlacklist = data.isUserOnPayOnSiteBlacklist;
            $scope.user = user;
            $scope.newCoupon.CODE = '';
            jQuery('#modal-point').removeClass('fade');
            jQuery('#modal-point').modal('hide');
            jQuery('#modal-add-coupon').removeClass('fade');
            jQuery('#modal-add-coupon').modal('hide');
            jQuery('#modal-view').modal('show');
          })
          .catch((err) => {
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
      };

      $scope.viewCar = (user) => {
        $scope.user = user;
        $resource(`${APIURL}/admin/users/:tb_user_id/usercars`, { tb_user_id: user.ID }).get((data) => {
          $scope.usercars = data.usercars;
          console.log(data.usercars);
          jQuery('#modal-usercars').modal('show');
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
      };

      $scope.deleteUserCar = (usercars, car) => {
        if (!confirm($translate.instant('정말로 삭제하시겠습니까?'))) {
          return;
        }
        $resource(`${APIURL}/admin/users/:tb_user_id/usercars/:tb_user_carinfo_id`, { tb_user_id: car.TB_USER_ID, tb_user_carinfo_id: car.ID }).delete(() => {
          usercars.splice(usercars.indexOf(car), 1);
          $scope.paging($scope.lastPage);
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
      };

      $scope.updateUserCarNo = (car) => {
        const carno = prompt($translate.instant('차량번호를 입력해 주세요')); // eslint-disable-line
        if (!carno || carno.length < 1) {
          alert($translate.instant('올바른 차량번호를 입력해 주세요 (4글자 이상)'));
          return;
        }

        $resource(`${APIURL}/admin/users/:tb_user_id/usercars/:tb_user_carinfo_id/carno`, { tb_user_id: car.TB_USER_ID, tb_user_carinfo_id: car.ID }).save({ CAR_NO: carno }, () => {
          car.CAR_NO = carno;
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
      };

      $scope.moveToWashHistory = (user) => {
        jQuery('#modal-view').removeClass('fade');
        jQuery('#modal-view').modal('hide');
        $location.path(`/member/${user.ID}/wash/history`);
      };

      $scope.delete = (user) => {
        if (!confirm($translate.instant('정말로 삭제하시겠습니까?'))) {
          return;
        }
        $resource(`${APIURL}/admin/users/:tb_user_id`, { tb_user_id: user.ID }).delete(
        () => {
          alert($translate.instant('삭제되었습니다'));
          $scope.users.splice($scope.users.indexOf(user), 1);
          jQuery('#modal-view').modal('hide');
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
      };

      $scope.addPoint = (user) => {
        if (user) {
          $scope.user = user;
        }
        $scope.newpoint = { PRICE: '' };
        jQuery('#modal-view').removeClass('fade');
        jQuery('#modal-view').modal('hide');
        jQuery('#modal-point').modal('show');
      };

      $scope.addCoupon = () => {
        jQuery('#modal-view').removeClass('fade');
        jQuery('#modal-view').modal('hide');
        jQuery('#modal-coupon').removeClass('fade');
        jQuery('#modal-coupon').modal('hide');
        jQuery('#modal-add-coupon').modal('show');
      };

      $scope.addCar = (user) => {
        jQuery('#modal-view').removeClass('fade');
        jQuery('#modal-view').modal('hide');
        jQuery('#modal-usercars').removeClass('fade');
        jQuery('#modal-usercars').modal('hide');
        $scope.user = user;
        $rootScope.user = user;
        $location.path('/member/car/add');
      };

      $scope.edit = (user) => {
        jQuery('#modal-view').removeClass('fade');
        jQuery('#modal-view').modal('hide');
        $location.path(`/member/${user.ID}`);
      };

      $scope.newpoint = { PRICE: '' };
      $scope.addPointSubmit = () => {
        const delta = parseInt($scope.newpoint.PRICE, 10);
        if ($scope.newpoint.PRICE === undefined || $scope.newpoint.PRICE === '' || Number.isNaN(delta) || delta === 0) {
          alert($translate.instant('포인트를 입력해주세요.'));
          return;
        }
        $resource(`${APIURL}/admin/users/${$scope.user.ID}/mileage/${delta}`).save({},
          (data) => {
            console.log(data);
            alert($translate.instant('포인트가 수정되었습니다.'));
            $scope.user.MILEAGE = parseInt($scope.user.MILEAGE, 10) + delta;
            jQuery('#modal-point').modal('hide');
            $scope.view($scope.user);
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
      };

      $scope.editCouponForm = { ID: null, CODE: '', PRICE: '', ENDDATE: '' };
      $scope.editCoupon = (coupon) => {
        if (!coupon || coupon.USED === 'Y') {
          return;
        }
        let end = '';
        if (coupon.ENDDATE_UTC) {
          end = moment(coupon.ENDDATE_UTC).utc().format('YYYY-MM-DD');
        }
        $scope.editCouponForm = {
          ID: coupon.ID,
          CODE: coupon.CODE,
          PRICE: coupon.PRICE,
          ENDDATE: end,
          _ref: coupon,
        };
        jQuery('#modal-edit-coupon').modal('show');
      };
      $scope.editCouponSubmit = () => {
        const price = parseInt($scope.editCouponForm.PRICE, 10);
        if (Number.isNaN(price) || price < 0) {
          alert($translate.instant('금액을 입력해주세요.'));
          return;
        }
        if (!$scope.editCouponForm.ENDDATE) {
          alert($translate.instant('유효기간을 입력해주세요.'));
          return;
        }
        $resource(`${APIURL}/admin/coupons/${$scope.editCouponForm.ID}/modify`).save({
          PRICE: price,
          ENDDATE: $scope.editCouponForm.ENDDATE,
        }).$promise
          .then((data) => {
            alert($translate.instant('수정되었습니다.'));
            if ($scope.editCouponForm._ref) {
              $scope.editCouponForm._ref.PRICE = price;
              if (data.coupon && data.coupon.ENDDATE_UTC) {
                $scope.editCouponForm._ref.ENDDATE_UTC = data.coupon.ENDDATE_UTC;
              }
            }
            jQuery('#modal-edit-coupon').modal('hide');
          })
          .catch((err) => { alertError(err); });
      };

      $scope.newCoupon = { CODE: '' };
      $scope.addCouonSubmit = () => {
        if (!$scope.newCoupon.CODE) {
          alert($translate.instant('할인쿠폰 정보를 입력해 주세요'));
          return;
        }
        $resource(`${APIURL}/admin/users/${$scope.user.ID}/coupon/${$scope.newCoupon.CODE}`).save($scope.newCoupon,
          (data) => {
            console.log(data);
            alert($translate.instant('할인쿠폰이 등록되었습니다.', { code: $scope.newCoupon.CODE }));
            $scope.paging(1);
            $scope.newCoupon.CODE = '';
            $location.path('/members');
            jQuery('#modal-add-coupon').modal('hide');
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
      };

      // 사용자 쿠폰
      $scope.viewCoupon = (user) => {
        $resource(`${APIURL}/admin/users/${user.ID}/coupons`).get((data) => {
          $scope.user = user;
          $scope.coupons = data.coupons;
          $scope.percent_coupons = data.percent_coupons;
          console.log(data);
          jQuery('#modal-coupon').modal('show');
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
      };
      $scope.deleteCoupon = (coupon) => {
        if (!confirm($translate.instant('정말로 삭제하시겠습니까?'))) {
          return;
        }
        $resource(`${APIURL}/admin/coupons/:coupon_id`, { coupon_id: coupon.ID, isGroup: false }).delete(
        () => {
          alert($translate.instant('삭제되었습니다'));
          $scope.coupons.splice($scope.coupons.indexOf(coupon), 1);
          $scope.user.COUPON_COUNT = $scope.coupons.length;
        }, (err) => { alertError(err); });
      };
      $scope.deletePercentCoupon = (coupon) => {
        if (!confirm($translate.instant('정말로 삭제하시겠습니까?'))) {
          return;
        }
        $resource(`${APIURL}/admin/percent/coupons/:coupon_id`, { coupon_id: coupon.ID, isGroup: false }).delete(
          () => {
            alert($translate.instant('삭제되었습니다'));
            $scope.coupons.splice($scope.coupons.indexOf(coupon), 1);
            $scope.user.COUPON_COUNT = $scope.coupons.length;
          }, (err) => { alertError(err); });
      };
      $scope.extendCoupon = (coupon) => {
        const days = $window.prompt($translate.instant('쿠폰 연장 기간을 입력해주세요.\n- 만료날짜 기준으로 입력하신 일수 만큼 연장됩니다.'), $translate.instant('예) 30'));
        if (!coupon || !days || parseInt(days, 10) < 1) {
          return;
        }
        if (!$window.confirm($translate.instant('쿠폰을 연장하시겠습니까?'))) { return; }
        $resource(`${APIURL}/admin/coupons/${coupon.ID}/extension`).save({ DAYS: days }).$promise
          .then(() => {
            alert($translate.instant('연장되었습니다.'));
            jQuery('#modal-coupon').modal('hide');
          })
          .catch((err) => { alertError(err); });
      };
      $scope.extendPercentCoupon = (coupon) => {
        const days = $window.prompt($translate.instant('쿠폰연장 기간을 입력해주세요. (단위, 일)'));
        if (!coupon || !days || parseInt(days, 10) < 1) {
          alert($translate.instant('알수 없는 에러 입니다.'));
          return;
        }
        if (!$window.confirm($translate.instant('쿠폰을 연장하시겠습니까?'))) { return; }
        $resource(`${APIURL}/admin/percent/coupons/${coupon.ID}/extension`).save({ DAYS: days }).$promise
          .then(() => {
            alert($translate.instant('연장되었습니다.'));
            jQuery('#modal-coupon').modal('hide');
          })
          .catch((err) => { alertError(err); });
      };
      $scope.registBlacklist = (user) => {
        const comment = $window.prompt($translate.instant('블랙리스트 등록 사유를 입력해주세요.'));
        if (!comment) {
          return;
        }
        if (comment.length < 1) {
          alert($translate.instant('블랙리스트 등록 사유를 입력해주세요.'));
          return;
        }
        $resource(`${APIURL}/admin/user/blacklist/payonsite`).save({ TB_USER_ID: user.ID, COMMENT: comment }).$promise
          .then(() => {
            alert($translate.instant('등록되었습니다.'));
            jQuery('#modal-view').modal('hide');
          })
          .catch((err) => {
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
      };
      $scope.unregistBlacklist = (user) => {
        $resource(`${envService.read('apiUrl')}/admin/user/blacklist/payonsite/${user.ID}`).delete().$promise
          .then(() => {
            alert($translate.instant('해제되었습니다.'));
            jQuery('#modal-view').modal('hide');
          })
          .catch((err) => {
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
      };

      $scope.downloadMemberList = () => {
        $resource(`${envService.read('apiUrl')}/admin/users.download`).get($scope.downloadUsersPayload).$promise
          .then((data) => {
            if (data.msg) {
              alert(data.msg);
            }
          })
          .catch((err) => {
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
      };

      $scope.viewDownloadPopup = () => {
        console.log('viewDownloadPopup');
        $scope.downloadUsersPayload = { ACCESS_MONTH: '0' };
        jQuery('#modal-users-download').modal('show');
      };
    })
    .controller('memberWashHistory', ($rootScope, $scope, $routeParams, $translate, $resource, $route, $location, $cookies, $window, AuthService, envService) => {
      $rootScope.mainmenu = 'members';
      $rootScope.menu = 'users';
      if (!AuthService.isAuthenticated()) {
        $location.path('/login');
        return;
      }
      const APIURL = envService.read('apiUrl');
      $scope.paging = (page) => {
        $scope.target_page = page;
        let status;
        if ($scope.target_status !== 'none') {
          status = $scope.target_status;
        }
        $resource(`${APIURL}/admin/orders`).get({ page: page - 1, q: $scope.queery, status, tb_user_id: $routeParams.user_id, tb_user_id_employee: $scope.target_employee, order: $scope.order, target_date: 'none', type: -1 }, (data) => {
          $scope.orders = data.orders;
          $scope.total_count = data.total_count;
          $scope.dates = data.dates;
          $scope.employees = data.employees;
          $scope.statuses = data.statuses;
          $scope.target_date = data.target_date;
          $scope.targetUser = data.user;

          for (let idx = 0; idx < $scope.dates.length; idx += 1) {
            if ($scope.dates[idx].DATEKEY === $scope.target_date) {
              $scope.target_date_idx = parseInt(idx, 10);
              $scope.target_date_txt = $scope.dates[idx].DATE_TXT;
              break;
            }
          }
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
      };
      $scope.view = (order) => {
        $scope.order = order;
        $resource(`${APIURL}/admin/orders/${order.ORDER_NO}`).get({}, (data) => {
          $scope.order = data.order;
          jQuery('#modal-order-view').modal('show');
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
      };
      $scope.isCanceled = (order) => {
        if (!order || !order.STATUS) { return false; }
        const status = parseInt(order.STATUS, 10);
        return status >= 96 && status <= 99;
      };
      $scope.viewCancelReasons = (orderNo, isConfirmedCancelRequest) => {
        $scope.reasons = [];
        if (isConfirmedCancelRequest) {
          $resource(`${APIURL}/admin/orders/cancel/request/reason/${orderNo}`).get({}).$promise
            .then((data) => {
              $scope.reasons.push(data.reason);
              jQuery('#modal-cancel-reasons').modal('show');
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        } else {
          $resource(`${APIURL}/admin/reasons/reserve/cancel/${orderNo}`).get({}).$promise
            .then((data) => {
              $scope.reasons = data.reasons;
              jQuery('#modal-cancel-reasons').modal('show');
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        }
      };
      $scope.edit = (order) => {
        jQuery('#modal-order-view').removeClass('fade');
        jQuery('#modal-order-view').modal('hide');
        $location.path(`/orders/${(order.ORDER_TYPE === 0) ? 'direct' : 'reserve'}/${order.ORDER_NO}/${$routeParams.user_id}`);
      };
      $scope.cancelOrder = (order, cancelPayment) => {
        const msg = $translate.instant('취소 사유를 입력해주세요.');
        const cancelComment = $window.prompt(msg);
        if (cancelComment === null || cancelComment === undefined || cancelComment.length < 1) {
          alert($translate.instant('취소 사유를 입력해주세요.'));
          return;
        }
        $resource(`${APIURL}/admin/orders/:order_no/cancel`, { order_no: order.ORDER_NO }).save({
          COMMENT: cancelComment,
          CANCEL_PAYMENT: cancelPayment,
        },
        () => {
          alert($translate.instant('취소되었습니다.'));
          order.STATUS = '98';
          order.STATUS_NAME = $translate.instant('세차취소(서버)');
          order.CANCEL_COMMENT = cancelComment;
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
      };
      $scope.total_count = 0;
      $scope.query = '';
      $scope.target_status = 'none';
      $scope.target_employee = '-1';
      $scope.paging(1);
    })
    .controller('MemberAddCtrl', ($rootScope, $scope, $translate, $resource, $route, $location, $cookies, $window, AuthService, envService, uiGmapGoogleMapApi, Upload) => {
      $rootScope.mainmenu = 'members';
      $rootScope.menu = 'users';
      const APIURL = envService.read('apiUrl');
      if (!AuthService.isAuthenticated()) {
        $location.path('/login');
        return;
      }
      $scope.is_editing = false;
      $resource(`${APIURL}/admin/cars/brands`).get((data) => {
        $scope.brands = data.brands;
      }, (err) => {
        console.error(err);
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });

      $resource(`${APIURL}/admin/affiliate`).get((data) => {
        $scope.affiliates = data.affiliates;
      }, (err) => {
        console.error(err);
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });
      $scope.member = { name: '',
        id: '',
        password: '',
        email: '',
        tel: '',
        profile_image: '',
        maker_name: '',
        maker_cd: '-1',
        car_name: '',
        car_cd: '-1',
        car_no: '',
        car_color: '',
        goods_id: '',
        addr: '',
        point: 0,
        coupon_code: '',
        affiliate_id: '-1',
        gender: '',
        birth: '' };
      $scope.affiliate = { };
      $scope.submit = () => {
        if ($scope.member.name.length < 1) {
          alert($translate.instant('이름을 입력해 주세요.'));
          return;
        }
        if ($scope.member.email.length < 1) {
          alert($translate.instant('이메일을 입력해 주세요.'));
          return;
        }
        if ($scope.member.affiliate_id > -1) {
          if (!$scope.member.email.includes($scope.affiliate.EMAIL_SUFFIX)) {
            alert($translate.instant('올바른 메일 도메인을 입력해주세요.') + $scope.affiliate.EMAIL_SUFFIX);
            return;
          }
        }
        if ($scope.member.password.length < 1) {
          alert($translate.instant('비밀번호를 입력해주세요.'));
          return;
        }
        if ($scope.member.tel.length < 1) {
          alert($translate.instant('전화번호를 입력해주세요.'));
          return;
        }
        if (parseInt($scope.member.maker_cd, 10) > 0 && parseInt($scope.member.car_cd, 10) < 1) {
          alert($translate.instant('차량을 선택해 주세요.'));
          return;
        }
        if (parseInt($scope.member.maker_cd, 10) > 0 && $scope.member.car_color < 1) {
          alert($translate.instant('차량 색상을 입력해주세요.'));
          return;
        }
        if (parseInt($scope.member.maker_cd, 10) > 0 && $scope.member.car_no.length < 1) {
          alert($translate.instant('차량번호를 입력해 주세요'));
          return;
        }
        if (parseInt($scope.member.maker_cd, 10) > 0) {
          for (let i = 0; i < $scope.brands.length; i += 1) {
            if ($scope.brands[i].MAKER_CD === $scope.member.maker_cd) {
              $scope.member.maker_name = $scope.brands[i].MAKER_NAME;
              break;
            }
          }
          for (let i = 0; i < $scope.cars.length; i += 1) {
            if ($scope.cars[i].ID === parseInt($scope.member.car_cd, 10)) {
              $scope.member.car_name = $scope.cars[i].CAR_NAME;
              $scope.member.goods_id = $scope.cars[i].TB_GOODS_ID;
              break;
            }
          }
        }
        $resource(`${APIURL}/admin/users`).save($scope.member, () => {
          if ($scope.member.affiliate_id > 0) {
            $location.path('/affiliate/user');
          } else {
            $location.path('/members');
          }
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
      };
      $scope.upload = (files) => {
        if (files && files.length) {
          const file = files[0];
          Upload.upload({
            url: `${APIURL}/admin/file/profile`,
            file,
          }).progress((evt) => {
            const progressPercentage = parseInt(100.0 * (evt.loaded / evt.total), 10);
            console.log(`progress: ${progressPercentage}% ${evt.config.file.name}`);
          }).success((data, status, headers, config) => {
            console.log(`file ${config.file.name}uploaded. Response: ${data}`);
            console.log(data);
            $scope.member.profile_image = data.url;
          });
        }
      };
      $scope.requestCarsWithMakerId = () => {
        if ($scope.member.maker_cd < 0) {
          $scope.cars = null;
          $scope.member.car_cd = '-1';
          return;
        }
        $resource(`${APIURL}/admin/cars/${$scope.member.maker_cd}`).get((data) => {
          $scope.cars = data.cars;
          $scope.member.car_cd = '-1';
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
      };
      $scope.requestAffiliates = () => {
        if ($scope.member.affiliate_id < 0) {
          $scope.affiliate = null;
          $scope.member.affiliate_id = '-1';
          return;
        }
        const matchedAffiliate = $scope.affiliates.filter(affiliate => affiliate.ID === parseInt($scope.member.affiliate_id, 10));
        if (matchedAffiliate) {
          $scope.affiliate = matchedAffiliate[0];
        }
      };
    })
    .controller('MemberInsightCtrl', ($rootScope, $scope, $translate, $resource, $route, $location, $cookies, $window, AuthService, envService) => {
      $rootScope.mainmenu = 'members';
      $rootScope.menu = 'insight';

      const APIURL = envService.read('apiUrl');
      if (!AuthService.isAuthenticated()) {
        $location.path('/login');
        return;
      }

      $scope.startDate = moment().add(-30, 'days').format('YYYY-MM-DD');
      $scope.endDate = moment().format('YYYY-MM-DD');
      $scope.startDateDisplay = moment().add(-30, 'days').format('MM월 DD일');
      $scope.endDateDisplay = moment().format('MM월 DD일');

      $scope.fetchData = () => {
        $resource(`${APIURL}/admin/insights/member`, { FROMDATE: $scope.startDate, ENDDATE: $scope.endDate }).get(
          (data) => {
            $scope.members = data;
            $scope.members.total = data.data[0][data.data[0].length - 1];
            $scope.members.diff = data.data[0][data.data[0].length - 1] - data.data[0][0];
          }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
        $resource(`${APIURL}/admin/insights/usercar`, { FROMDATE: $scope.startDate, ENDDATE: $scope.endDate }).get(
          (data) => {
            $scope.usercars = data;
            $scope.usercars.total = data.data[0][data.data[0].length - 1];
            $scope.usercars.diff = data.data[0][data.data[0].length - 1] - data.data[0][0];
          }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
        $resource(`${APIURL}/admin/insights/member/areas`, { FROMDATE: $scope.startDate, ENDDATE: $scope.endDate }).get(
        (data) => {
          $scope.member_areas = data;
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
        $resource(`${APIURL}/admin/insights/usercar/areas`, { FROMDATE: $scope.startDate, ENDDATE: $scope.endDate }).get(
          (data) => {
            $scope.usercars_areas = data;
          }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
        $resource(`${APIURL}/admin/insights/member/os`, { FROMDATE: $scope.startDate, ENDDATE: $scope.endDate }).get(
          (data) => {
            $scope.member_os = data;
          }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
        $resource(`${APIURL}/admin/insights/member/login`, { FROMDATE: $scope.startDate, ENDDATE: $scope.endDate }).get(
          (data) => {
            $scope.member_login = data;
          }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
      };

      $('#reservation').val(`${$scope.startDate} ~ ${$scope.endDate}`); // eslint-disable-line
      $('#reservation').daterangepicker(null, (start, end) => { // eslint-disable-line
        $scope.startDate = start.format('YYYY-MM-DD');
        $scope.endDate = end.format('YYYY-MM-DD');
        $scope.startDateDisplay = start.format('MM월 DD일');
        $scope.endDateDisplay = end.format('MM월 DD일');
        $scope.fetchData();
      });
      $scope.fetchData();
    });



// WEBPACK FOOTER //
// ./src/app/member/member.js